module.exports = __webpack_public_path__ + "img/general-ambrose-burnside.4aa66cc9.png";